import i18next from "src/i18n/config";

import { Theme } from "@mui/material";
import { highLatencyThresholdMs } from "@screenView/api/ScreenViewClient";
import { StreamingMode } from "@screenView/types";

export function getStreamingModeLabel(streamingMode: StreamingMode) {
    switch (streamingMode) {
        case StreamingMode.H264:
            return i18next.t("pages:screenViewPage.mode.h264");
        case StreamingMode.Screenshot:
            return i18next.t("pages:screenViewPage.mode.screenshot");
        case StreamingMode.Adaptive:
            return i18next.t("pages:screenViewPage.mode.adaptive");
        default:
            return i18next.t("common:status.unknown");
    }
}

export function getStreamingModeColor(streamingMode: StreamingMode, currentRTT: number, theme: Theme) {
    switch (streamingMode) {
        case StreamingMode.H264:
            return theme.palette.emteria.success;
        case StreamingMode.Screenshot:
            return theme.palette.emteria.warning;
        case StreamingMode.Adaptive:
            return currentRTT > highLatencyThresholdMs ? theme.palette.emteria.warning : theme.palette.emteria.success;
        default:
            return theme.palette.emteria.background.disabled;
    }
}
